import { gql } from 'apollo-boost'

const SCRAPING_TAG_GROUPS_OPTIONS = gql`
  query scrapingTagGroupsOptions {
    scrapingTagGroupsOptions {
      id
      name
    }
  }
`

export default SCRAPING_TAG_GROUPS_OPTIONS
